<template>
  <div class="team-permission-button">
    <div
      v-if="disabled"
      class="disabled"
    >
      Disabled
    </div>
    <DpplSubMenu
      v-if="!disabled && user.status === 'active'"
      :margin="false"
      :selected-option="getPermissions"
      :sub-menu-options="subMenuOptions"
      :loading="loading"
      :disabled="!canTeamAdmin && user.status === 'active'"
      :should-open-on-hover="false"
      reduce-font-size
      :chip-height="28"
      @submit-sub-menu="(value) => $emit('submitSubMenu', { action: value, id: user.id })"
    />
  </div>
</template>

<script>
import DpplSubMenu from '@/components/datapeople/DpplSubMenu.vue';

export default {
  name: 'TeamPermissionButtons',
  components: {
    DpplSubMenu,
  },
  props: {
    user: { type: Object, default: () => ({}) },
    disabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    canTeamAdmin: { type: Boolean, default: true },
    status: { type: String, default: 'inactive' },
  },
  emits: ['submitSubMenu'],
  computed: {
    getPermissions() {
      if (this.user.status === 'active' && this.user.isAdmin) {
        return 'Admin';
      }
      return 'Editor';
    },
    subMenuOptions() {
      if (this.user.status === 'active') {
        return this.user.isAdmin
          ? [{ id: 'revoke', value: 'Editor' }]
          : [{ id: 'grant', value: 'Admin' }];
      }
      return [];
    },
  },
};
</script>

<style lang="less" scoped>
.team-permission-button {
  display: flex;
  align-items: center;
}
.disabled {
  font-size: 12px;
  font-weight: 500;
  line-height: 150%;
  pointer-events: none;
  opacity: 0.4;
}
</style>
